export default "__VITE_ASSET__RjEH9Whq__"